module.exports = __webpack_public_path__ + "static/nk_fly-b5f526eba3e69a8e2a774ec20ee2880a.png";